export default "__VITE_ASSET__BR4j8OO1__"